import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            
        </div>
    );
};

export default DashboardHome;